/* REPLAY V2 (2026-10-31, Rob: "a dynamic way to view replays that knows what kind of stream it is ... smooth and corporate").
   THE PLAYER, built BESIDE the current one (assets/livereplay.js stays untouched and is what everyone gets unless Replay v2 is switched on).
   WHO     views/_post.php stamps <div class="lr2" data-lr2="<post id>" data-lr2-manifest="..."> ONLY while ReplayManifest::enabled()
           (k/v replay_v2, or ?replay=2 for an admin / replay_v2_users). This file finds those mounts and builds the player in them.
   DATA    ONE request: GET /post-replay?id=<post>&manifest=1 (lib/replaymanifest.php): kind, orientation, parts (signed MP4 + HLS), the layout
           timeline (who was on stage), chat / gift / like density, battles, board games, chapters. The chat + gift side feed reads the
           existing windowed GET /post-replay (same visibility rules as the classic player).
   PICTURE The recording is ONE composite video per part and is ALWAYS shown whole: a rounded card whose box has the video's own aspect
           (never stretched, never cropped, never swapped for avatar tiles). Who is on stage, the battle / game in progress and a
           "resumed at" note are written under the card, never over the picture.
   MODULES (one file): Model (parts <-> one clock, segments) | Engine (decks, source ladder mp4 -> hls -> hls.js, stall recovery, resume,
           preload next part) | Bar (slim progress + marker lane + hover preview + scrub) | Controls (ONE row) | Feed (chat + gifts) | UI glue.
   TOKENS  signed Cloudflare URLs are renewed by assets/app.js (window.__rovaCf): the mount carries data-renew-post, the <video> carries
           data-hls and, with hls.js, v._hls, which is everything its 20 s sweep and the hls.js loader patch look for.
   KEYS    space / k play, left / right 5 s, j / l 10 s, up / down volume, m mute, f fullscreen, c chat, < > speed, 0-9 jump, Home / End.
           Horizontal trackpad swipe over the card or the bar scrubs. Debug: window.__rovaReplay2. */
(function () {
  'use strict';
  if (window.__rovaReplay2) { return; }
  var SCRIPT = document.currentScript;
  var HLS_URL = (SCRIPT && SCRIPT.getAttribute('data-hls')) || '/assets/hls.min.js';
  var SPEEDS = [1, 1.25, 1.5, 2];
  var PREF = 'rova.lr2.';
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ------------------------------------------------------------------ tiny helpers ------------------------------------------------------------------ */
  function el(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (attrs) { for (var k in attrs) { if (attrs[k] != null) { n.setAttribute(k, attrs[k]); } } }
    return n;
  }
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
  function store(k, v) {
    try { if (v === undefined) { return window.localStorage.getItem(PREF + k); } if (v === null) { window.localStorage.removeItem(PREF + k); } else { window.localStorage.setItem(PREF + k, String(v)); } } catch (e) {}
    return null;
  }
  function fmt(ms) {
    var s = Math.max(0, Math.floor(ms / 1000)), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), x = s % 60;
    return (h ? h + ':' + (m < 10 ? '0' : '') + m : m) + ':' + (x < 10 ? '0' : '') + x;
  }
  function spoken(ms) {
    var s = Math.max(0, Math.floor(ms / 1000)), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), x = s % 60, o = [];
    if (h) { o.push(h + (h === 1 ? ' hour' : ' hours')); } if (m) { o.push(m + (m === 1 ? ' minute' : ' minutes')); } if (x || !o.length) { o.push(x + (x === 1 ? ' second' : ' seconds')); }
    return o.join(' ');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function safeUrl(u) { return typeof u === 'string' && (/^https:\/\//.test(u) || /^\/[^\/]/.test(u)) ? u : ''; }
  function ico(name) {
    var P = {
      play: '<path d="M8 5.5v13l11-6.5z" fill="currentColor" stroke="none"/>',
      pause: '<path d="M7 5h3.4v14H7zM13.6 5H17v14h-3.4z" fill="currentColor" stroke="none"/>',
      back: '<path d="M12 5V2L7.5 6 12 10V7a6 6 0 1 1-6 6"/><text x="12" y="16.2" font-size="6.6" font-weight="700" text-anchor="middle" fill="currentColor" stroke="none" font-family="system-ui,sans-serif">10</text>',
      fwd: '<path d="M12 5V2l4.5 4L12 10V7a6 6 0 1 0 6 6"/><text x="12" y="16.2" font-size="6.6" font-weight="700" text-anchor="middle" fill="currentColor" stroke="none" font-family="system-ui,sans-serif">10</text>',
      vol: '<path d="M4 9.5v5h3.5L12 18.5v-13L7.5 9.5z" fill="currentColor" stroke="none"/><path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11"/>',
      mute: '<path d="M4 9.5v5h3.5L12 18.5v-13L7.5 9.5z" fill="currentColor" stroke="none"/><path d="M16 9.5l5 5M21 9.5l-5 5"/>',
      chat: '<path d="M5 5.5h14a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5H11l-4.5 3.5v-3.5H5A1.5 1.5 0 0 1 3.5 15V7A1.5 1.5 0 0 1 5 5.5z"/>',
      share: '<path d="M12 15V4M8 8l4-4 4 4"/><path d="M5 12v6.5A1.5 1.5 0 0 0 6.5 20h11a1.5 1.5 0 0 0 1.5-1.5V12"/>',
      full: '<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>',
      exit: '<path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5"/>',
      more: '<circle cx="5.5" cy="12" r="1.7" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.7" fill="currentColor" stroke="none"/><circle cx="18.5" cy="12" r="1.7" fill="currentColor" stroke="none"/>',
      check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>'
    };
    return '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + (P[name] || '') + '</svg>';
  }
  function btn(cls, icon, label) {
    var b = el('button', 'lr2-b ' + cls, { type: 'button', 'aria-label': label, title: label });
    if (icon) { b.innerHTML = ico(icon); }
    return b;
  }
  function hlsLib(cb) {
    if (window.Hls) { cb(!!window.Hls.isSupported && window.Hls.isSupported()); return; }
    if (hlsLib.q) { hlsLib.q.push(cb); return; }
    hlsLib.q = [cb];
    var s = document.createElement('script');
    s.src = HLS_URL; s.async = true;
    s.onload = function () { var q = hlsLib.q; hlsLib.q = null; q.forEach(function (f) { f(!!(window.Hls && window.Hls.isSupported && window.Hls.isSupported())); }); };
    s.onerror = function () { var q = hlsLib.q; hlsLib.q = null; q.forEach(function (f) { f(false); }); };
    document.head.appendChild(s);
  }
  function getJson(url, tries) {
    return fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'fetch' }, cache: 'no-store' }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || !j || j.ok === false) { var e = new Error((j && j.message) || ('HTTP ' + r.status)); e.status = r.status; e.body = j; throw e; }
        return j;
      });
    }).catch(function (e) {
      if (tries > 0 && (!e.status || e.status >= 500 || e.status === 429)) { return new Promise(function (ok) { setTimeout(ok, 700); }).then(function () { return getJson(url, tries - 1); }); }
      throw e;
    });
  }

  /* ------------------------------------------------------------------ MODEL: parts <-> one clock ------------------------------------------------------------------ */
  function Model(m) {
    this.m = m;
    this.parts = (m.sources && m.sources.parts || []).slice();
    this.dur = Math.max(0, +m.duration_ms || 0);
    var end = 0, i;
    for (i = 0; i < this.parts.length; i++) { end = Math.max(end, (this.parts[i].start_ms || 0) + (this.parts[i].dur_ms || 0)); }
    if (!this.dur || end > this.dur) { this.dur = end || this.dur; }
  }
  Model.prototype.partAt = function (ms) {   // the part that holds clock ms, or the next one after a gap (never beyond the last)
    var p = this.parts, i;
    for (i = 0; i < p.length; i++) { var a = p[i].start_ms || 0, b = a + (p[i].dur_ms || 0); if (ms >= a && ms < b) { return { i: i, t: (ms - a) / 1000, gap: false }; } }
    for (i = 0; i < p.length; i++) { if (ms < (p[i].start_ms || 0)) { return { i: i, t: 0, gap: true }; } }
    var last = p.length - 1; return { i: last, t: Math.max(0, (p[last].dur_ms || 0) / 1000 - 0.05), gap: false };
  };
  Model.prototype.segAt = function (ms) {
    var s = this.m.segments || [], i;
    for (i = 0; i < s.length; i++) { if (ms >= s[i].from_ms && ms < s[i].to_ms) { return s[i]; } }
    return null;
  };
  Model.prototype.person = function (id) { var p = this.m.people || [], i; for (i = 0; i < p.length; i++) { if (p[i].id === id) { return p[i]; } } return null; };
  Model.prototype.now = function (ms) {   // { text, who[] } for the line under the card
    var m = this.m, o = m.overlays || {}, i, x, text = '';
    var inside = function (a) { return ms >= a.from_ms && ms < a.to_ms; };
    for (i = 0; i < (o.battles || []).length; i++) { x = o.battles[i]; if (inside(x)) { text = 'Battle vs ' + (x.right && x.right.name || 'opponent'); } }
    if (!text) {
      for (i = 0; i < (o.board || []).length; i++) {
        x = o.board[i];
        if (inside(x)) { var nm = (x.players || []).map(function (p) { return p.name || p.username; }).filter(Boolean); text = x.label + (nm.length ? ': ' + nm.slice(0, 4).join(' vs ') : ''); }
      }
    }
    if (!text) { for (i = 0; i < (o.games || []).length; i++) { x = o.games[i]; if (inside(x)) { text = x.label + (x.question ? ': ' + x.question : ''); } } }
    if (!text) { for (i = 0; i < (o.links || []).length; i++) { x = o.links[i]; if (inside(x)) { text = 'Co-host with ' + x.name; } } }
    var seg = this.segAt(ms), who = [];
    if (seg && seg.uids) { for (i = 0; i < seg.uids.length; i++) { var pp = this.person(seg.uids[i]); if (pp) { who.push(pp); } } }
    if (!text && seg && seg.kind === 'room' && who.length > 1) { text = 'Room'; }
    if (!text && seg && seg.kind === 'call' && who.length > 1) { text = 'Call'; }
    return { text: text, who: who, seg: seg };
  };

  /* ------------------------------------------------------------------ the player ------------------------------------------------------------------ */
  function Player(root) {
    this.root = root;
    this.pid = +root.getAttribute('data-lr2') || 0;
    this.url = root.getAttribute('data-lr2-manifest') || ('/post-replay?id=' + this.pid + '&manifest=1&replay=2');
    this.m = null; this.model = null;
    this.decks = []; this.cur = 0;            // two decks (A / B): the next part preloads on the idle one
    this.partIdx = 0; this.ladder = []; this.rung = 0;
    this.wantPlay = true; this.autoMuted = false; this.userMuted = false;
    this.scrubbing = false; this.pendingSeek = null; this.seekTimer = 0;
    this.stalls = []; this.recoveries = 0; this.stallTimer = 0; this.spinTimer = 0;
    this.lastClock = 0; this.saveAt = 0; this.dead = false; this.resumed = null;
    this.feed = null;
    this.build();
    this.load();
  }

  Player.prototype.build = function () {
    var self = this, r = this.root;
    var ar = parseFloat(r.getAttribute('data-lr2-ar')) || 0.5625;
    r.classList.add('lr2-on');
    r.setAttribute('role', 'region'); r.setAttribute('aria-label', 'Live replay'); r.tabIndex = 0;
    r.style.setProperty('--ar', String(ar));
    r.innerHTML = '';
    var wrap = el('div', 'lr2-wrap'); this.wrap = wrap;
    var main = el('div', 'lr2-main'); this.main = main;
    var card = el('div', 'lr2-card'); this.card = card;
    var poster = el('div', 'lr2-poster'); this.posterEl = poster;
    var ps = safeUrl(r.getAttribute('data-lr2-poster') || '');
    if (ps) { poster.style.backgroundImage = 'url("' + ps.replace(/"/g, '%22') + '")'; }
    card.appendChild(poster);
    this.decks = [this.makeDeck(), this.makeDeck()];
    card.appendChild(this.decks[0].v); card.appendChild(this.decks[1].v);
    this.decks[1].v.classList.add('lr2-off');
    var state = el('div', 'lr2-state'); this.stateEl = state; card.appendChild(state);
    this.setState('loading');
    main.appendChild(card);

    // the ONE control area: slim bar (+ marker lane), one row
    var ctl = el('div', 'lr2-ctl'); this.ctl = ctl;
    var bar = el('div', 'lr2-bar', { role: 'slider', tabindex: '0', 'aria-label': 'Seek', 'aria-valuemin': '0', 'aria-valuemax': '0', 'aria-valuenow': '0', 'aria-valuetext': '0:00' }); this.barEl = bar;
    var lane = el('canvas', 'lr2-lane', { 'aria-hidden': 'true' }); this.lane = lane;
    var track = el('div', 'lr2-track'); this.track = track;
    var buf = el('div', 'lr2-buf'); var fill = el('div', 'lr2-fill'); var knob = el('div', 'lr2-knob');
    this.bufEl = buf; this.fillEl = fill; this.knob = knob;
    track.appendChild(buf); track.appendChild(fill); track.appendChild(knob);
    var tip = el('div', 'lr2-tip', { 'aria-hidden': 'true' }); this.tip = tip;
    tip.innerHTML = '<div class="lr2-tip-img"></div><div class="lr2-tip-t"></div><div class="lr2-tip-l"></div>';
    bar.appendChild(lane); bar.appendChild(track); bar.appendChild(tip);
    ctl.appendChild(bar);

    var row = el('div', 'lr2-row'); this.row = row;
    this.bPlay = btn('lr2-play', 'play', 'Play');
    this.bBack = btn('lr2-skip', 'back', 'Back 10 seconds');
    this.bFwd = btn('lr2-skip', 'fwd', 'Forward 10 seconds');
    this.timeEl = el('div', 'lr2-time', { 'aria-hidden': 'true' }); this.timeEl.textContent = '0:00 / 0:00';
    var sp = el('span', 'lr2-sp');
    this.bSpeed = el('button', 'lr2-b lr2-speed', { type: 'button', 'aria-label': 'Playback speed 1x', title: 'Playback speed', 'aria-haspopup': 'menu' }); this.bSpeed.textContent = '1x';
    var volw = el('div', 'lr2-volw');
    this.bVol = btn('lr2-vol', 'mute', 'Unmute');
    this.volR = el('input', 'lr2-volr', { type: 'range', min: '0', max: '1', step: '0.02', value: '1', 'aria-label': 'Volume' });
    volw.appendChild(this.bVol); volw.appendChild(this.volR);
    this.bFeed = btn('lr2-feedb', 'chat', 'Chat and gifts'); this.bFeed.setAttribute('aria-pressed', 'false'); this.bFeed.hidden = true;
    this.bShare = btn('lr2-sharebtn', 'share', 'Share');
    this.bFull = btn('lr2-fs', 'full', 'Full screen');
    this.bMore = btn('lr2-more', 'more', 'More'); this.bMore.setAttribute('aria-haspopup', 'menu');
    var left = el('div', 'lr2-rl'); left.appendChild(this.bPlay); left.appendChild(this.bBack); left.appendChild(this.bFwd); left.appendChild(this.timeEl);
    var right = el('div', 'lr2-rr'); [this.bSpeed, volw, this.bFeed, this.bShare, this.bFull, this.bMore].forEach(function (n) { right.appendChild(n); });
    row.appendChild(left); row.appendChild(sp); row.appendChild(right);
    ctl.appendChild(row);
    main.appendChild(ctl);

    // under the card: who / what is on right now (never over the picture)
    var info = el('div', 'lr2-info'); this.infoEl = info;
    info.innerHTML = '<div class="lr2-head"><span class="lr2-av"></span><div class="lr2-hd"><div class="lr2-title"></div><div class="lr2-sub"></div></div></div><div class="lr2-now" aria-live="polite"></div><div class="lr2-who"></div><div class="lr2-note"></div>';
    main.appendChild(info);
    wrap.appendChild(main);
    var feed = el('aside', 'lr2-feed', { 'aria-label': 'Chat and gifts', hidden: '' }); this.feedEl = feed; wrap.appendChild(feed);
    r.appendChild(wrap);
    this.live = el('div', 'lr2-sr', { 'aria-live': 'polite', role: 'status' }); r.appendChild(this.live);
    this.toastEl = el('div', 'lr2-toast', { 'aria-hidden': 'true' }); card.appendChild(this.toastEl);
    this.menuEl = null;
    this.wire();
  };

  Player.prototype.makeDeck = function () {
    var v = el('video', 'lr2-v', { playsinline: '', 'webkit-playsinline': '', preload: 'auto', 'disablepictureinpicture': '' });
    v.setAttribute('disableRemotePlayback', ''); v.muted = true; v.playsInline = true; v.controls = false;
    return { v: v, part: -1, kind: '', hls: null, ready: false };
  };

  Player.prototype.deck = function () { return this.decks[this.cur]; };
  Player.prototype.vid = function () { return this.decks[this.cur].v; };

  /* ------------------------------------------------------------------ manifest ------------------------------------------------------------------ */
  Player.prototype.load = function () {
    var self = this;
    getJson(this.url, 1).then(function (m) { if (!self.dead) { self.start(m); } }, function (e) { self.fail(e); });
  };

  Player.prototype.fail = function (e) {
    this.setState('error', e && e.status === 404 ? 'This replay is not available.' : 'This replay did not load.', true);
  };

  Player.prototype.start = function (m) {
    var self = this;
    this.m = m; this.model = new Model(m);
    if (!this.model.parts.length || !(this.model.parts[0].mp4 || this.model.parts[0].hls)) { this.setState('error', 'This replay cannot be played right now.', true); return; }
    // the card takes the picture's own shape; a later part in another orientation eases the box over to its shape
    this.setAspect(m.aspect || (m.frame && m.frame.w / m.frame.h) || 0.5625, true);
    this.root.setAttribute('data-kind', m.kind || 'solo'); this.root.setAttribute('data-orient', m.orientation || 'portrait');
    var host = m.host || {};
    this.infoEl.querySelector('.lr2-title').textContent = m.title || 'Live replay';
    this.infoEl.querySelector('.lr2-sub').textContent = [(host.display_name || host.username || ''), 'Live replay', fmt(this.model.dur)].filter(Boolean).join(' \u00b7 ');
    var av = this.infoEl.querySelector('.lr2-av');
    if (safeUrl(host.avatar)) { var im = el('img', '', { alt: '', width: '36', height: '36', decoding: 'async' }); im.src = host.avatar; av.appendChild(im); } else { av.textContent = (host.display_name || host.username || '?').charAt(0).toUpperCase(); }
    this.barEl.setAttribute('aria-valuemax', String(Math.round(this.model.dur / 1000)));
    this.drawLane();
    if ((m.markers && ((m.markers.chat || []).length || (m.markers.gifts || []).length)) || (m.feed && m.feed.url)) { this.bFeed.hidden = false; }
    // where to begin: ?t=, else where this browser stopped, else the start
    var start = 0, q = /[?&]t=(\d+)/.exec(location.search + location.hash);
    if (q) { start = +q[1] * 1000; }
    else {
      var sv = store('pos.' + this.pid);
      if (sv) { var o = null; try { o = JSON.parse(sv); } catch (e) {} if (o && o.t > 8000 && o.t < this.model.dur - 12000 && o.d === Math.round(this.model.dur / 1000)) { start = o.t; this.resumed = o.t; } }
    }
    var sr = parseFloat(store('rate')); if (sr && SPEEDS.indexOf(sr) >= 0) { this.setRate(sr, true); }
    var vol = parseFloat(store('vol')); this.volR.value = String(isNaN(vol) ? 1 : clamp(vol, 0, 1));
    this.openPart(this.model.partAt(start), true);
    this.updateInfo(start);
    if (this.resumed != null) { this.note('Resumed at ' + fmt(this.resumed), 'Start over', function () { self.seekClock(0); self.note(''); }); }
    this.observe();
  };

  Player.prototype.setAspect = function (ar, instant) {
    if (!(ar > 0.2 && ar < 5)) { return; }
    var r = this.root;
    if (instant || RM) { r.classList.add('lr2-noanim'); }
    r.style.setProperty('--ar', String(Math.round(ar * 10000) / 10000));
    r.setAttribute('data-orient', ar > 1.05 ? 'landscape' : (ar < 0.95 ? 'portrait' : 'square'));
    if (instant || RM) { var q = this.root; window.requestAnimationFrame(function () { q.classList.remove('lr2-noanim'); }); }
  };

  /* ------------------------------------------------------------------ the engine ------------------------------------------------------------------ */
  Player.prototype.ladderFor = function (part) {
    var o = (this.m.sources && this.m.sources.order) || ['mp4', 'hls'], out = [], i;
    for (i = 0; i < o.length; i++) { if (part[o[i]]) { out.push(o[i]); } }
    if (part.hls_lo) { out.push('hls_lo'); }
    if (!out.length) { out = part.hls ? ['hls'] : []; }
    /* SAFARI / iPHONE PLAYS THE STREAM FIRST (2026-11-04, Rob: tapping a Recently-live replay on Safari only showed the still picture). The ladder starts with the progressive MP4 (Cloudflare's /downloads/default.mp4:
       a whole 36-59 minute 1080p file, which has to be generated and then range-read), and on Apple's player that stalls on the poster instead of failing over. Apple's own HLS (ABR + seeking, no download needed) goes first. */
    try {
      var probe = document.createElement('video');
      if (part.hls && probe.canPlayType && probe.canPlayType('application/vnd.apple.mpegurl') && out.indexOf('hls') > 0) { out.splice(out.indexOf('hls'), 1); out.unshift('hls'); }
    } catch (e) {}
    return out;
  };

  /* open part pos.i on the active deck at pos.t seconds; keepPlay carries the playing state across */
  Player.prototype.openPart = function (pos, first) {
    var d = this.deck(), part = this.model.parts[pos.i];
    this.partIdx = pos.i; this.ladder = this.ladderFor(part); this.rung = 0; this.recoveries = 0;
    var oa = part.w && part.h ? part.w / part.h : 0;
    if (oa && !first) { this.setAspect(oa); }
    this.attach(d, pos.i, pos.t, this.wantPlay);
    this.markPreload(false);
  };

  Player.prototype.srcFor = function (part, kind) { return part[kind] || ''; };

  Player.prototype.detach = function (d) {
    if (d.hls) { try { d.hls.destroy(); } catch (e) {} d.hls = null; d.v._hls = null; }
    d.ready = false;
    if (d.unbind) { d.unbind(); d.unbind = null; }
  };

  Player.prototype.attach = function (d, partIdx, startSec, play, kindOverride) {
    var self = this, v = d.v, part = this.model.parts[partIdx], kind = kindOverride || this.ladder[this.rung] || 'mp4', idle = d !== this.deck();
    var url = this.srcFor(part, kind);
    this.detach(d);
    d.part = partIdx; d.kind = kind;
    v.removeAttribute('src'); try { v.load(); } catch (e) {}
    v.setAttribute('data-hls', part.hls || ''); if (part.hls_lo) { v.setAttribute('data-hls-lo', part.hls_lo); }
    v.setAttribute('data-uid', part.uid || '');
    v.defaultPlaybackRate = v.playbackRate = this.rate || 1;   // a new src resets playbackRate to the default: set both
    var applied = false;
    var onMeta = function () {
      if (applied) { return; } applied = true; d.ready = true;
      var dur = v.duration;
      if (isFinite(dur) && dur > 0 && part.dur_ms && Math.abs(dur * 1000 - part.dur_ms) > 1500) { part.dur_ms = Math.round(dur * 1000); self.model.dur = Math.max(self.model.dur, (part.start_ms || 0) + part.dur_ms); }
      if (startSec > 0.2) { try { v.currentTime = Math.min(startSec, Math.max(0, (dur || startSec) - 0.1)); } catch (e) {} }
      if (d === self.deck()) { self.setState(null); self.syncUI(); }
    };
    var on = {
      loadedmetadata: onMeta, loadeddata: onMeta,
      canplay: function () { if (d !== self.deck()) { return; } self.clearStall(); self.setState(null); self.poster(false); },
      playing: function () { if (d !== self.deck()) { return; } self.clearStall(); self.setState(null); self.poster(false); self.syncPlay(); },
      pause: function () { self.syncPlay(); },
      waiting: function () { if (d === self.deck()) { self.onWaiting(); } },
      stalled: function () { if (d === self.deck() && !v.paused) { self.onWaiting(); } },
      seeking: function () { if (d === self.deck()) { self.onWaiting(true); } },
      seeked: function () { self.clearStall(); },
      timeupdate: function () { if (d === self.deck()) { self.tick(); } },
      progress: function () { if (d === self.deck()) { self.drawBuffer(); } },
      ended: function () { if (d === self.deck()) { self.onEnded(); } },
      volumechange: function () { self.syncVol(); },
      ratechange: function () { self.syncRate(); },
      error: function () { if (d === self.deck()) { self.onError(); } }
    };
    for (var k in on) { v.addEventListener(k, on[k]); }
    d.unbind = function () { for (var k in on) { v.removeEventListener(k, on[k]); } };
    if (kind === 'hls' || kind === 'hls_lo') { this.attachHls(d, url, startSec, play, onMeta); }
    else { v.preload = 'auto'; v.src = url; }
    if (play) { this.tryPlay(v); }
    if (!idle) { this.setState('loading'); }
  };

  Player.prototype.attachHls = function (d, url, startSec, play, onMeta) {
    var self = this, v = d.v;
    if (v.canPlayType('application/vnd.apple.mpegurl')) { v.src = url; return; }   // Safari / iOS: the system's own HLS (ABR + seeking)
    hlsLib(function (ok) {
      if (!ok || d.part < 0 || self.dead) { if (!ok) { self.nextRung('hls.js missing'); } return; }
      var h = new window.Hls({ capLevelToPlayerSize: true, startPosition: startSec > 0.2 ? startSec : -1, maxBufferLength: 60, maxMaxBufferLength: 120, backBufferLength: 30,
                               enableWorker: true, lowLatencyMode: false, startLevel: d.kind === 'hls_lo' ? 0 : -1, autoStartLoad: true });
      d.hls = h; v._hls = h;
      h.on(window.Hls.Events.ERROR, function (ev, data) {
        if (!data || !data.fatal) { return; }
        if (data.type === window.Hls.ErrorTypes.NETWORK_ERROR && (d.hlsRetry = (d.hlsRetry || 0) + 1) <= 3) { try { h.startLoad(); } catch (e) {} return; }
        if (data.type === window.Hls.ErrorTypes.MEDIA_ERROR && (d.hlsMedia = (d.hlsMedia || 0) + 1) <= 2) { try { h.recoverMediaError(); } catch (e) {} return; }
        if (d === self.deck()) { self.onError(); }
      });
      h.on(window.Hls.Events.MANIFEST_PARSED, function () { if (d.kind === 'hls_lo') { try { h.currentLevel = 0; } catch (e) {} } onMeta(); });   // data saver: pinned to the lightest rung
      h.loadSource(url); h.attachMedia(v);
    });
  };

  Player.prototype.tryPlay = function (v) {
    var self = this, p;
    try { p = v.play(); } catch (e) { p = null; }
    if (p && p.catch) {
      p.catch(function (e) {
        if (self.dead || !e || e.name !== 'NotAllowedError') { return; }   // an abort / a broken source is the error handler's business
        // autoplay with sound is refused: start muted (autoplay always allowed), the first gesture unmutes
        if (!v.muted) { v.muted = true; self.autoMuted = true; var p2; try { p2 = v.play(); } catch (x) { p2 = null; } if (p2 && p2.catch) { p2.catch(function () { self.needGesture(); }); } }
        else { self.needGesture(); }
      });
    }
  };
  Player.prototype.needGesture = function () { this.wantPlay = false; this.setState('paused'); this.syncPlay(); };

  /* stalls: a spinner only after 450 ms (no flicker on a quick seek); after ~7 s of no progress re-source at the same spot; 3 recoveries -> next rung */
  Player.prototype.onWaiting = function (seek) {
    var self = this;
    if (this.stallTimer) { return; }
    if (!this.spinTimer) { this.spinTimer = setTimeout(function () { self.spinTimer = 0; if (!self.vid().paused || self.pendingSeek != null || self.vid().seeking) { self.setState('buffering'); } }, 450); }
    var t0 = this.vid().currentTime;
    this.stallTimer = setTimeout(function () {
      self.stallTimer = 0;
      var v = self.vid();
      if (self.dead || (v.paused && !v.seeking)) { return; }
      if (v.readyState >= 3 && Math.abs(v.currentTime - t0) > 0.05) { return; }
      self.recover();
    }, seek ? 9000 : 7000);
  };
  Player.prototype.clearStall = function () {
    if (this.stallTimer) { clearTimeout(this.stallTimer); this.stallTimer = 0; }
    if (this.spinTimer) { clearTimeout(this.spinTimer); this.spinTimer = 0; }
    if (this.state === 'buffering') { this.setState(null); }
  };
  Player.prototype.recover = function () {
    var v = this.vid(), t = v.currentTime || 0;
    this.recoveries++;
    this.setState('buffering', 'Still buffering. Your connection looks slow.');
    if (this.recoveries >= 3) { this.nextRung('stalled'); return; }
    // re-ask the manifest for fresh URLs (token / CDN), then re-open the same spot
    var self = this;
    getJson(this.url, 0).then(function (m) {
      if (self.dead) { return; }
      var np = m.sources && m.sources.parts && m.sources.parts[self.partIdx];
      if (np) { var op = self.model.parts[self.partIdx]; op.mp4 = np.mp4 || op.mp4; op.hls = np.hls || op.hls; op.hls_lo = np.hls_lo || op.hls_lo; }
      self.attach(self.deck(), self.partIdx, t, self.wantPlay);
    }, function () { self.attach(self.deck(), self.partIdx, t, self.wantPlay); });
  };
  Player.prototype.nextRung = function () {
    var v = this.vid(), t = v.currentTime || 0;
    if (this.rung + 1 < this.ladder.length) {
      this.rung++; this.recoveries = 0;
      this.attach(this.deck(), this.partIdx, t, this.wantPlay);
    } else {
      this.setState('error', 'Playback stopped. Your connection may have dropped.', true);
    }
  };
  Player.prototype.onError = function () {
    var self = this, v = this.vid();
    if (this.renewTried !== this.partIdx + ':' + this.rung && window.__rovaCf) {
      this.renewTried = this.partIdx + ':' + this.rung;   // once per rung: a refused token is renewed before the source is given up on
      var t = v.currentTime || 0;
      getJson(this.url, 0).then(function (m) {
        var np = m.sources && m.sources.parts && m.sources.parts[self.partIdx];
        if (np) { var op = self.model.parts[self.partIdx]; op.mp4 = np.mp4 || op.mp4; op.hls = np.hls || op.hls; op.hls_lo = np.hls_lo || op.hls_lo; }
        self.attach(self.deck(), self.partIdx, t, self.wantPlay);
      }, function () { self.nextRung(); });
      return;
    }
    this.nextRung();
  };

  Player.prototype.onEnded = function () {
    var next = this.partIdx + 1, parts = this.model.parts;
    if (next < parts.length) {
      // the next part was preloading on the idle deck: swap decks (no gap), play on
      var d2 = this.decks[1 - this.cur];
      if (d2.part === next && d2.ready) { this.swapTo(d2, 0); return; }
      this.openPart({ i: next, t: 0 }, false); return;
    }
    this.wantPlay = false; this.syncPlay(); this.setState('ended');
    store('pos.' + this.pid, null);
  };

  Player.prototype.swapTo = function (d2, startSec) {
    var old = this.deck(), v2 = d2.v;
    if (startSec > 0) { try { v2.currentTime = startSec; } catch (e) {} }
    v2.muted = old.v.muted; v2.volume = old.v.volume; v2.playbackRate = this.rate || 1;
    v2.classList.remove('lr2-off'); old.v.classList.add('lr2-off');
    this.cur = 1 - this.cur; this.partIdx = d2.part;
    var part = this.model.parts[d2.part];
    this.ladder = this.ladderFor(part); this.rung = Math.max(0, this.ladder.indexOf(d2.kind)); this.recoveries = 0;
    if (part.w && part.h) { this.setAspect(part.w / part.h); }
    old.v.pause(); this.detach(old); old.part = -1;
    this.tryPlay(v2); this.markPreload(false); this.syncPlay();
  };

  /* the idle deck loads the next part a little before it is needed */
  Player.prototype.markPreload = function () {
    var next = this.partIdx + 1, parts = this.model.parts, idle = this.decks[1 - this.cur];
    if (next >= parts.length) { if (idle.part >= 0 && idle.part !== next) { this.detach(idle); idle.part = -1; idle.v.removeAttribute('src'); } return; }
    if (idle.part === next) { return; }
    var v = this.vid(), left = isFinite(v.duration) ? v.duration - v.currentTime : 999;
    if (left > 45 && parts[this.partIdx].dur_ms > 60000) { return; }
    var part = parts[next], kind = this.ladderFor(part)[0];
    if (!kind) { return; }
    idle.v.muted = true;
    this.attach(idle, next, 0, false, kind);   // the same wiring as the active deck, so the swap needs nothing else
  };

  /* ------------------------------------------------------------------ clock / seek ------------------------------------------------------------------ */
  Player.prototype.clockMs = function () {
    if (this.pendingSeek != null) { return this.pendingSeek; }
    var v = this.vid(), part = this.model && this.model.parts[this.partIdx];
    if (!part) { return 0; }
    return (part.start_ms || 0) + Math.round((v.currentTime || 0) * 1000);
  };
  /* SMOOTH SEEKING: a burst of seeks (arrow keys, trackpad swipe, repeated taps) is folded into ONE seek to the last target after 120 ms;
     the bar and time follow the target at once, so the UI never waits for the network. Inside the buffered range the seek is instant. */
  Player.prototype.seekClock = function (ms, now) {
    var self = this;
    ms = clamp(ms, 0, Math.max(0, this.model.dur - 250));
    this.pendingSeek = ms; this.syncUI(); this.updateInfo(ms);
    if (this.seekTimer) { clearTimeout(this.seekTimer); }
    var go = function () {
      self.seekTimer = 0;
      var target = self.pendingSeek; if (target == null) { return; }
      var pos = self.model.partAt(target);
      if (pos.i !== self.partIdx) {
        self.pendingSeek = null; self.openPart(pos, false); self.poster(false);
      } else {
        var v = self.vid();
        var f = (v.fastSeek && !self.wantPlay) ? 'fastSeek' : null;
        try { if (f) { v.fastSeek(pos.t); } else { v.currentTime = pos.t; } } catch (e) {}
        self.pendingSeek = null;
        if (self.wantPlay && v.paused) { self.tryPlay(v); }
      }
      if (self.state === 'ended') { self.setState(null); }
      self.syncUI();
      self.persist(true);
    };
    if (now) { go(); } else { this.seekTimer = setTimeout(go, 120); }
  };
  Player.prototype.skip = function (sec) { this.seekClock(this.clockMs() + sec * 1000); };

  Player.prototype.tick = function () {
    var ms = this.clockMs(), self = this;
    this.lastClock = ms;
    if (!this.scrubbing) { this.syncUI(); }
    this.updateInfo(ms);
    if (this.feed) { this.feed.sync(ms); }
    if (Date.now() - this.saveAt > 4000) { this.persist(); }
    // preload the next part as the end approaches
    if (this.model.parts.length > 1) { this.markPreload(); }
  };
  Player.prototype.persist = function () {
    this.saveAt = Date.now();
    var ms = this.lastClock;
    if (this.model && ms > 8000 && ms < this.model.dur - 12000) { store('pos.' + this.pid, JSON.stringify({ t: ms, d: Math.round(this.model.dur / 1000), at: Date.now() })); }
  };

  /* ------------------------------------------------------------------ state layer (loading / buffering / error / paused / ended) ------------------------------------------------------------------ */
  Player.prototype.setState = function (st, msg, retry) {
    var s = this.stateEl, self = this;
    this.state = st;
    s.className = 'lr2-state' + (st ? ' lr2-s-' + st : '');
    if (!st) { s.innerHTML = ''; return; }
    var h = '';
    if (st === 'loading' || st === 'buffering') {
      h = '<div class="lr2-spin" role="presentation"></div>' + (msg ? '<div class="lr2-msg">' + esc(msg) + '</div>' : '');
      if (st === 'loading') { s.classList.add('lr2-soft'); }
    } else if (st === 'paused') {
      h = '<button type="button" class="lr2-bigplay" aria-label="Play replay">' + ico('play') + '</button>';
    } else if (st === 'ended') {
      h = '<button type="button" class="lr2-bigplay lr2-again" aria-label="Watch again">' + ico('play') + '</button><div class="lr2-msg">Replay finished</div>';
    } else if (st === 'error') {
      h = '<div class="lr2-err"><div class="lr2-msg">' + esc(msg || 'This replay hit a snag.') + '</div>' + (retry ? '<div class="lr2-errb"><button type="button" class="lr2-pill lr2-retry">Try again</button> <a class="lr2-pill lr2-ghost" href="' + esc(this.classicUrl()) + '">Open classic player</a></div>' : '') + '</div>';
    }
    s.innerHTML = h;
    var big = s.querySelector('.lr2-bigplay');
    if (big) { big.addEventListener('click', function (e) { e.stopPropagation(); if (self.state === 'ended') { self.seekClock(0, true); } self.play(); }); }
    var rt = s.querySelector('.lr2-retry');
    if (rt) { rt.addEventListener('click', function () { if (self.m && self.model) { self.renewTried = ''; self.recoveries = 0; self.rung = 0; self.attach(self.deck(), self.partIdx, self.lastClock / 1000 - (self.model.parts[self.partIdx].start_ms || 0) / 1000, true); } else { self.setState('loading'); self.load(); } }); }
    if (st === 'buffering' || st === 'error') { this.live.textContent = msg || (st === 'buffering' ? 'Buffering' : 'Playback problem'); }
  };
  Player.prototype.poster = function (on) { this.posterEl.classList.toggle('lr2-gone', !on); };
  Player.prototype.classicUrl = function () {
    var u = location.pathname + (location.search ? location.search.replace(/([?&])replay=\d/, '$1').replace(/[?&]$/, '') : '');
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'replay=1';
  };

  /* ------------------------------------------------------------------ play / volume / rate ------------------------------------------------------------------ */
  Player.prototype.play = function () { this.wantPlay = true; var v = this.vid(); if (this.state === 'paused') { this.setState(null); } this.tryPlay(v); this.firstGesture(); this.syncPlay(); };
  Player.prototype.pause = function () { this.wantPlay = false; this.vid().pause(); this.syncPlay(); };
  Player.prototype.toggle = function () { if (this.vid().paused) { this.play(); } else { this.pause(); } };
  Player.prototype.firstGesture = function () {   // autoplay started muted: the first real gesture brings the sound in (unless the member muted it)
    if (this.autoMuted && !this.userMuted) { this.autoMuted = false; this.setMuted(false); this.root.classList.remove('lr2-hint'); }
  };
  Player.prototype.setMuted = function (m) {
    var i; for (i = 0; i < 2; i++) { this.decks[i].v.muted = m; }
    if (!m && this.vid().volume === 0) { this.setVol(0.7); }
    this.syncVol();
  };
  Player.prototype.setVol = function (x) { x = clamp(x, 0, 1); var i; for (i = 0; i < 2; i++) { this.decks[i].v.volume = x; } this.volR.value = String(x); store('vol', x); if (x > 0) { this.setMuted(false); } this.syncVol(); };
  Player.prototype.setRate = function (r, quiet) {
    this.rate = r; var i; for (i = 0; i < 2; i++) { this.decks[i].v.defaultPlaybackRate = r; this.decks[i].v.playbackRate = r; }
    store('rate', r); this.syncRate();
    if (!quiet) { this.live.textContent = 'Speed ' + r + 'x'; }
  };

  Player.prototype.syncPlay = function () {
    var p = this.vid().paused, ended = this.state === 'ended';
    this.bPlay.innerHTML = ico(p || ended ? 'play' : 'pause');
    this.bPlay.setAttribute('aria-label', p || ended ? 'Play' : 'Pause'); this.bPlay.title = p || ended ? 'Play (space)' : 'Pause (space)';
    this.root.classList.toggle('lr2-playing', !p);
    if (p && !this.wantPlay && !this.state && !this.vid().seeking && this.vid().readyState > 0) { /* quiet pause: the controls say it */ }
  };
  Player.prototype.syncVol = function () {
    var v = this.vid(), m = v.muted || v.volume === 0;
    this.bVol.innerHTML = ico(m ? 'mute' : 'vol');
    this.bVol.setAttribute('aria-label', m ? 'Unmute' : 'Mute'); this.bVol.title = m ? 'Unmute (m)' : 'Mute (m)';
    this.root.classList.toggle('lr2-muted', m);
    this.root.classList.toggle('lr2-hint', m && this.autoMuted && !this.userMuted);
    if (document.activeElement !== this.volR) { this.volR.value = String(m ? 0 : v.volume); }
  };
  Player.prototype.syncRate = function () {
    var r = this.rate || 1;
    this.bSpeed.textContent = r + 'x'; this.bSpeed.setAttribute('aria-label', 'Playback speed ' + r + 'x. Change speed');
    this.root.classList.toggle('lr2-fast', r !== 1);
  };

  /* ------------------------------------------------------------------ the bar ------------------------------------------------------------------ */
  Player.prototype.syncUI = function () {
    if (!this.model) { return; }
    var ms = this.clockMs(), dur = this.model.dur || 1, f = clamp(ms / dur, 0, 1);
    this.fillEl.style.transform = 'scaleX(' + f + ')';
    this.knob.style.left = (f * 100) + '%';
    this.timeEl.textContent = fmt(ms) + ' / ' + fmt(dur);
    this.barEl.setAttribute('aria-valuenow', String(Math.round(ms / 1000)));
    this.barEl.setAttribute('aria-valuetext', spoken(ms) + ' of ' + spoken(dur));
    this.drawBuffer();
  };
  Player.prototype.drawBuffer = function () {
    if (!this.model) { return; }
    var v = this.vid(), part = this.model.parts[this.partIdx], dur = this.model.dur || 1, b = v.buffered, t = v.currentTime, e = 0, i;
    try { for (i = 0; i < b.length; i++) { if (b.start(i) <= t + 0.5 && b.end(i) >= t) { e = b.end(i); } } } catch (x) {}
    var endMs = (part.start_ms || 0) + Math.round(Math.max(e, t) * 1000);
    this.bufEl.style.transform = 'scaleX(' + clamp(endMs / dur, 0, 1) + ')';
  };
  Player.prototype.drawLane = function () {
    var c = this.lane, m = this.m, mk = m.markers || {}, dur = this.model.dur || 1;
    var w = Math.max(10, this.barEl.clientWidth || 300), h = 18, dpr = Math.min(2, window.devicePixelRatio || 1);
    c.width = Math.round(w * dpr); c.height = Math.round(h * dpr); c.style.height = h + 'px';
    var g = c.getContext('2d'); if (!g) { return; }
    g.setTransform(dpr, 0, 0, dpr, 0, 0); g.clearRect(0, 0, w, h);
    var X = function (ms) { return clamp(ms / dur, 0, 1) * w; }, i, a, b;
    // hearts: a soft gold floor
    var likes = mk.likes || [], mx = 0;
    for (i = 0; i < likes.length; i++) { mx = Math.max(mx, likes[i][1]); }
    if (mx > 0) { g.fillStyle = 'rgba(245,197,24,0.22)'; for (i = 0; i < likes.length; i++) { var lh = 2 + 8 * Math.sqrt(likes[i][1] / mx); g.fillRect(X(likes[i][0]), h - lh, Math.max(2, (mk.bucket_ms || 5000) / dur * w), lh); } }
    // chat: quiet ticks
    var chat = mk.chat || []; mx = 0;
    for (i = 0; i < chat.length; i++) { mx = Math.max(mx, chat[i][1]); }
    g.fillStyle = 'rgba(255,255,255,0.5)';
    for (i = 0; i < chat.length; i++) { var ch = 3 + 9 * Math.min(1, chat[i][1] / Math.max(2, mx)); g.fillRect(Math.round(X(chat[i][0])), h - ch, 2, ch); }
    // battles / games / cuts: thin ribbons on the floor
    var rib = function (list, col, y) { g.fillStyle = col; for (var j = 0; j < list.length; j++) { a = X(list[j].t_ms != null ? list[j].t_ms : list[j].from_ms); b = X(list[j].to_ms != null ? list[j].to_ms : (list[j].t_ms || 0) + 1000); g.fillRect(a, y, Math.max(2, b - a), 3); } };
    rib(mk.battle || [], 'rgba(255,90,106,0.9)', h - 3);
    rib(mk.game || [], 'rgba(124,168,255,0.9)', h - 3);
    rib(((m.overlays && m.overlays.paused) || []), 'rgba(255,255,255,0.35)', h - 3);
    // gifts: gold dots (bigger = the biggest few)
    var gifts = mk.gifts || [], big = mk.big_gifts || [];
    g.fillStyle = '#f5c518';
    for (i = 0; i < gifts.length; i++) { g.beginPath(); g.arc(X(gifts[i][0]) + 1, 4, 2.4, 0, 6.283); g.fill(); }
    for (i = 0; i < big.length; i++) { g.beginPath(); g.arc(X(big[i]) + 1, 4, 3.6, 0, 6.283); g.fill(); }
    // chapters: small notches
    var chs = mk.chapters || []; g.fillStyle = 'rgba(255,255,255,0.8)';
    for (i = 0; i < chs.length; i++) { if (chs[i].kind === 'resume') { continue; } g.fillRect(Math.round(X(chs[i].t_ms)), 0, 1, 6); }
  };
  Player.prototype.labelAt = function (ms) {
    var mk = (this.m && this.m.markers) || {}, bk = mk.bucket_ms || 5000, i, out = [], x;
    var rng = function (list, lab) { for (var j = 0; j < list.length; j++) { var a = list[j].t_ms, b = list[j].to_ms != null ? list[j].to_ms : a + 1000; if (ms >= a - 1500 && ms <= b) { return list[j].label || lab; } } return ''; };
    x = rng(mk.battle || [], 'Battle'); if (x) { out.push(x); }
    x = rng(mk.game || [], 'Game'); if (x) { out.push(x); }
    var chs = mk.chapters || [];
    for (i = 0; i < chs.length; i++) { if (chs[i].kind !== 'resume' && Math.abs(chs[i].t_ms - ms) < Math.max(4000, this.model.dur / 80)) { out.push(chs[i].label); break; } }
    var cnt = function (list) { var n = 0, g = 0; for (var j = 0; j < list.length; j++) { if (list[j][0] <= ms && ms < list[j][0] + bk) { n += list[j][1]; g += list[j][2] || 0; } } return [n, g]; };
    var gf = cnt(mk.gifts || []); if (gf[0]) { out.push(gf[0] + (gf[0] === 1 ? ' gift' : ' gifts')); }
    var ct = cnt(mk.chat || []); if (ct[0]) { out.push(ct[0] + (ct[0] === 1 ? ' message' : ' messages')); }
    return out.slice(0, 3).join(' \u00b7 ');
  };
  Player.prototype.fracAt = function (e) { var r = this.track.getBoundingClientRect(); return clamp((e.clientX - r.left) / Math.max(1, r.width), 0, 1); };
  Player.prototype.hover = function (e) {
    if (!this.model) { return; }
    var f = this.fracAt(e), ms = f * this.model.dur, br = this.barEl.getBoundingClientRect(), tip = this.tip;
    var w = tip.offsetWidth || 120, x = clamp(e.clientX - br.left, w / 2, Math.max(w / 2, br.width - w / 2));
    tip.style.left = x + 'px'; tip.classList.add('lr2-on');
    tip.querySelector('.lr2-tip-t').textContent = fmt(ms);
    tip.querySelector('.lr2-tip-l').textContent = this.labelAt(ms);
    this.thumbAt(ms);
  };
  Player.prototype.thumbAt = function (ms) {
    var part = this.model.parts[this.model.partAt(ms).i], box = this.tip.querySelector('.lr2-tip-img'), self = this;
    if (!part || !part.thumbs) { box.style.display = 'none'; return; }
    var pos = this.model.partAt(ms), sec = Math.floor(pos.t / 5) * 5;
    var url = part.thumbs.replace('{s}', String(sec));
    if (this.thumbUrl === url) { return; }
    this.thumbUrl = url;
    clearTimeout(this.thumbTimer);
    this.thumbTimer = setTimeout(function () {
      var im = new Image();
      im.onload = function () { if (self.thumbUrl === url) { box.style.backgroundImage = 'url("' + url + '")'; box.style.display = 'block'; } };
      im.onerror = function () { box.style.display = 'none'; };
      im.src = url;
    }, 110);
  };

  /* ------------------------------------------------------------------ under the card: now + on stage + note ------------------------------------------------------------------ */
  Player.prototype.updateInfo = function (ms) {
    if (!this.model) { return; }
    var n = this.model.now(ms), key = n.text + '|' + n.who.map(function (w) { return w.id; }).join(',');
    if (key === this.infoKey) { return; }
    this.infoKey = key;
    var now = this.infoEl.querySelector('.lr2-now'), who = this.infoEl.querySelector('.lr2-who');
    now.textContent = n.text; now.classList.toggle('lr2-has', !!n.text);
    var h = '', i, max = 6;
    if (n.who.length > 1) {
      for (i = 0; i < n.who.length && i < max; i++) {
        var p = n.who[i], tile = null, s = n.seg && n.seg.tiles || [], j;
        for (j = 0; j < s.length; j++) { if (s[j].user_id === p.id) { tile = s[j]; break; } }
        h += '<span class="lr2-chip' + (tile && tile.camera_off ? ' lr2-camoff' : '') + '">' + (safeUrl(p.avatar) ? '<img alt="" width="22" height="22" loading="lazy" decoding="async" src="' + esc(p.avatar) + '">' : '<i>' + esc((p.display_name || '?').charAt(0).toUpperCase()) + '</i>') + '<b>' + esc(p.display_name || p.username) + '</b></span>';
      }
      if (n.who.length > max) { h += '<span class="lr2-chip lr2-more">+' + (n.who.length - max) + '</span>'; }
    }
    who.innerHTML = h;
  };
  Player.prototype.note = function (text, actionLabel, action) {
    var n = this.infoEl.querySelector('.lr2-note');
    n.innerHTML = ''; if (!text) { return; }
    n.appendChild(document.createTextNode(text));
    if (actionLabel) { var b = el('button', 'lr2-link', { type: 'button' }); b.textContent = actionLabel; b.addEventListener('click', action); n.appendChild(document.createTextNode(' \u00b7 ')); n.appendChild(b); }
    var self = this; clearTimeout(this.noteTimer); this.noteTimer = setTimeout(function () { n.innerHTML = ''; }, 9000);
  };
  Player.prototype.toast = function (t) {
    var e = this.toastEl; e.textContent = t; e.classList.add('lr2-on'); this.live.textContent = t;
    clearTimeout(this.toastTimer); this.toastTimer = setTimeout(function () { e.classList.remove('lr2-on'); }, 1800);
  };

  /* ------------------------------------------------------------------ menus (speed, more) ------------------------------------------------------------------ */
  Player.prototype.closeMenu = function () { if (this.menuEl) { this.menuEl.remove(); this.menuEl = null; if (this.menuBtn) { this.menuBtn.setAttribute('aria-expanded', 'false'); this.menuBtn.focus(); } } };
  Player.prototype.openMenu = function (anchor, title, items) {
    var self = this;
    if (this.menuEl && this.menuBtn === anchor) { this.closeMenu(); return; }
    this.closeMenu();
    var m = el('div', 'lr2-menu', { role: 'menu', 'aria-label': title });
    items.forEach(function (it) {
      if (it.head) { var hd = el('div', 'lr2-mh'); hd.textContent = it.head; m.appendChild(hd); return; }
      var b = el('button', 'lr2-mi' + (it.on ? ' lr2-sel' : ''), { type: 'button', role: it.radio ? 'menuitemradio' : 'menuitem', 'aria-checked': it.radio ? (it.on ? 'true' : 'false') : null });
      b.innerHTML = '<span class="lr2-ml"></span>' + (it.right ? '<span class="lr2-mr"></span>' : '') + (it.on ? '<span class="lr2-mc">' + ico('check') + '</span>' : '');
      b.querySelector('.lr2-ml').textContent = it.label; if (it.right) { b.querySelector('.lr2-mr').textContent = it.right; }
      b.addEventListener('click', function (e) { e.stopPropagation(); self.closeMenu(); it.run(); });
      m.appendChild(b);
    });
    this.ctl.appendChild(m); this.menuEl = m; this.menuBtn = anchor; anchor.setAttribute('aria-expanded', 'true');
    var ar = anchor.getBoundingClientRect(), cr = this.ctl.getBoundingClientRect();
    m.style.right = Math.max(4, cr.right - ar.right) + 'px';
    var first = m.querySelector('.lr2-sel') || m.querySelector('.lr2-mi'); if (first) { first.focus(); }
    m.addEventListener('keydown', function (e) {
      var bs = [].slice.call(m.querySelectorAll('.lr2-mi')), i = bs.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); e.stopPropagation(); bs[(i + 1) % bs.length].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); e.stopPropagation(); bs[(i - 1 + bs.length) % bs.length].focus(); }
      else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); self.closeMenu(); }
      else if (e.key === 'Tab') { self.closeMenu(); }
    });
  };
  Player.prototype.speedMenu = function () {
    var self = this;
    this.openMenu(this.bSpeed, 'Playback speed', SPEEDS.map(function (s) { return { label: s === 1 ? 'Normal' : s + 'x', right: s === 1 ? '1x' : '', radio: true, on: (self.rate || 1) === s, run: function () { self.setRate(s); } }; }));
  };
  Player.prototype.moreMenu = function () {
    var self = this, items = [], chs = ((this.m.markers && this.m.markers.chapters) || []).filter(function (c) { return c.kind !== 'resume' && c.kind !== 'cut'; });
    if (this.feedAvailable()) { items.push({ label: this.feed && this.feed.open ? 'Hide chat and gifts' : 'Show chat and gifts', run: function () { self.toggleFeed(); } }); }
    items.push({ label: 'Copy link at this time', run: function () { self.share(true); } });
    var lo = this.ladder[this.rung] === 'hls_lo';
    var hasLo = this.model.parts[this.partIdx] && (this.model.parts[this.partIdx].hls_lo || this.model.parts[this.partIdx].hls);
    if (hasLo) { items.push({ label: 'Data saver', right: lo ? 'On' : 'Off', run: function () { self.dataSaver(!lo); } }); }
    if (chs.length) {
      items.push({ head: 'Chapters' });
      chs.slice(0, 12).forEach(function (c) { items.push({ label: c.label, right: fmt(c.t_ms), run: function () { self.seekClock(c.t_ms, true); } }); });
    }
    items.push({ head: 'Player' });
    items.push({ label: 'Open classic player', run: function () { location.href = self.classicUrl(); } });
    this.openMenu(this.bMore, 'More', items);
  };
  Player.prototype.dataSaver = function (on) {
    var part = this.model.parts[this.partIdx], t = this.vid().currentTime || 0;
    this.ladder = on ? ['hls_lo'].concat(this.ladderFor(part).filter(function (k) { return k !== 'hls_lo'; })) : this.ladderFor(part);
    if (on && !part.hls_lo) { part.hls_lo = part.hls; }
    this.rung = 0; this.attach(this.deck(), this.partIdx, t, this.wantPlay);
    this.toast(on ? 'Data saver on' : 'Data saver off');
  };

  /* ------------------------------------------------------------------ share / fullscreen ------------------------------------------------------------------ */
  Player.prototype.shareUrl = function (withTime) {
    var u = location.origin + location.pathname, t = Math.floor(this.clockMs() / 1000);
    return u + (withTime && t > 5 ? '?t=' + t : '');
  };
  Player.prototype.share = function (copyOnly) {
    var self = this, url = this.shareUrl(true), title = (this.m && this.m.title) || 'Live replay';
    var copy = function () {
      var done = function () { self.toast('Link copied'); };
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(url).then(done, function () { self.toast(url); }); }
      else { var ta = el('textarea'); ta.value = url; ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); done(); } catch (e) { self.toast(url); } ta.remove(); }
    };
    if (!copyOnly && navigator.share) { navigator.share({ title: title, url: url }).catch(function (e) { if (e && e.name !== 'AbortError') { copy(); } }); } else { copy(); }
  };
  Player.prototype.isFull = function () { return document.fullscreenElement === this.root || document.webkitFullscreenElement === this.root; };
  Player.prototype.fullscreen = function () {
    var r = this.root, v = this.vid();
    if (this.isFull()) { (document.exitFullscreen || document.webkitExitFullscreen).call(document); return; }
    if (r.requestFullscreen) { r.requestFullscreen().catch(function () {}); }
    else if (r.webkitRequestFullscreen) { r.webkitRequestFullscreen(); }
    else if (v.webkitEnterFullscreen) { v.webkitEnterFullscreen(); }   // iPhone: the system player (no custom controls there)
  };
  Player.prototype.syncFull = function () {
    var f = this.isFull();
    this.root.classList.toggle('lr2-full', f);
    this.bFull.innerHTML = ico(f ? 'exit' : 'full'); this.bFull.setAttribute('aria-label', f ? 'Exit full screen' : 'Full screen'); this.bFull.title = f ? 'Exit full screen (f)' : 'Full screen (f)';
    var self = this; setTimeout(function () { self.drawLane(); }, 60);
  };

  /* ------------------------------------------------------------------ chat + gifts feed ------------------------------------------------------------------ */
  Player.prototype.feedAvailable = function () { return !!(this.m && this.m.feed && this.m.feed.url); };
  Player.prototype.toggleFeed = function () {
    if (!this.feedAvailable()) { return; }
    if (!this.feed) { this.feed = new Feed(this); }
    this.feed.set(!this.feed.open);
  };

  function Feed(p) {
    this.p = p; this.el = p.feedEl; this.open = false; this.rows = []; this.have = {}; this.wins = {}; this.busy = {}; this.lastShown = -1;
    this.el.innerHTML = '<div class="lr2-fh"><span>Chat and gifts</span><button type="button" class="lr2-fx" aria-label="Close chat and gifts">&times;</button></div><div class="lr2-fl" role="log" aria-live="off" tabindex="0"></div><div class="lr2-fe">Nothing here yet.</div>';
    this.list = this.el.querySelector('.lr2-fl'); this.empty = this.el.querySelector('.lr2-fe');
    var self = this; this.el.querySelector('.lr2-fx').addEventListener('click', function () { self.set(false); });
  }
  Feed.prototype.set = function (on) {
    this.open = !!on; this.el.hidden = !on; this.p.root.classList.toggle('lr2-has-feed', on);
    this.p.bFeed.setAttribute('aria-pressed', on ? 'true' : 'false');
    store('feed', on ? '1' : '0');
    if (on) { this.lastShown = -1; this.sync(this.p.clockMs(), true); }
    var p = this.p; setTimeout(function () { p.drawLane(); }, 80);
  };
  Feed.prototype.win = function (idx) {
    var self = this, p = this.p, W = (p.m.feed.window_ms || 120000);
    if (this.wins[idx] || this.busy[idx]) { return; }
    this.busy[idx] = 1;
    var u = p.m.feed.url + '&from=' + (idx * W) + '&to=' + ((idx + 1) * W);
    getJson(u, 1).then(function (j) {
      self.busy[idx] = 0; self.wins[idx] = 1;
      (j.rows || []).forEach(function (r) {
        var k = r.kind + ':' + r.id; if (self.have[k] || r.kind === 'join' || typeof r.t_ms !== 'number') { return; }
        self.have[k] = 1; self.rows.push(r);
      });
      self.rows.sort(function (a, b) { return a.t_ms - b.t_ms; });
      if (j.more && j.next_from_ms != null) { self.wins[idx] = 0; }   // a capped window: read on from where it stopped
      self.render(p.clockMs());
    }, function () { self.busy[idx] = 0; });
  };
  Feed.prototype.sync = function (ms, force) {
    if (!this.open) { return; }
    var W = this.p.m.feed.window_ms || 120000, idx = Math.floor(ms / W);
    this.win(idx); if (ms % W > W - 25000) { this.win(idx + 1); } if (idx > 0 && ms % W < 20000) { this.win(idx - 1); }
    var sec = Math.floor(ms / 1500);
    if (!force && sec === this.lastShown) { return; }
    this.lastShown = sec; this.render(ms);
  };
  Feed.prototype.render = function (ms) {
    var vis = [], i, r;
    for (i = this.rows.length - 1; i >= 0 && vis.length < 60; i--) { r = this.rows[i]; if (r.t_ms <= ms) { vis.unshift(r); } }
    this.empty.hidden = vis.length > 0;
    var sig = vis.length ? vis[0].kind + vis[0].id + '/' + vis[vis.length - 1].id + '/' + vis.length : '';
    if (sig === this.sig) { return; }
    this.sig = sig;
    var h = '';
    for (i = 0; i < vis.length; i++) {
      r = vis[i]; var u = r.user || {}, name = esc(u.short_name || u.display_name || u.username || '');
      if (r.kind === 'gift' || (r.gift && r.event !== 'sticker')) {
        var g = r.gift || {}; var art = safeUrl(g.art);
        h += '<div class="lr2-fr lr2-fg">' + (art ? '<img alt="" width="24" height="24" loading="lazy" src="' + esc(art) + '">' : '') + '<span><b>' + name + '</b> sent ' + esc(g.name || 'a gift') + (r.qty > 1 ? ' \u00d7' + (+r.qty) : '') + '</span></div>';
      } else if (r.kind === 'chat') {
        h += '<div class="lr2-fr"><b>' + name + '</b> <span>' + esc(r.body) + '</span></div>';
      } else {
        h += '<div class="lr2-fr lr2-fs"><span>' + esc(r.named_body || r.body) + '</span></div>';
      }
    }
    this.list.innerHTML = h;
    this.list.scrollTop = this.list.scrollHeight;   // the newest line is always the one at the bottom
  };

  /* ------------------------------------------------------------------ events ------------------------------------------------------------------ */
  Player.prototype.wire = function () {
    var self = this, r = this.root, bar = this.barEl;
    // controls
    this.bPlay.addEventListener('click', function () { self.toggle(); });
    this.bBack.addEventListener('click', function () { self.skip(-10); });
    this.bFwd.addEventListener('click', function () { self.skip(10); });
    this.bSpeed.addEventListener('click', function (e) { e.stopPropagation(); self.speedMenu(); });
    this.bVol.addEventListener('click', function () {
      var v = self.vid(); self.autoMuted = false;
      if (v.muted || v.volume === 0) { self.userMuted = false; self.setMuted(false); } else { self.userMuted = true; self.setMuted(true); }
    });
    this.volR.addEventListener('input', function () { self.autoMuted = false; self.userMuted = false; self.setVol(parseFloat(self.volR.value)); });
    this.bFeed.addEventListener('click', function () { self.toggleFeed(); });
    this.bShare.addEventListener('click', function () { self.share(false); });
    this.bFull.addEventListener('click', function () { self.fullscreen(); });
    this.bMore.addEventListener('click', function (e) { e.stopPropagation(); self.moreMenu(); });
    document.addEventListener('fullscreenchange', function () { self.syncFull(); });
    document.addEventListener('webkitfullscreenchange', function () { self.syncFull(); });
    document.addEventListener('click', function (e) { if (self.menuEl && !self.menuEl.contains(e.target)) { self.closeMenu(); } });
    // the picture: tap = play / pause; the first gesture of any kind brings the sound in
    var tapT = 0;
    this.card.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.lr2-state button, .lr2-state a')) { return; }
      self.firstGesture(); self.toggle();
    });
    this.card.addEventListener('dblclick', function (e) { e.preventDefault(); self.fullscreen(); });
    r.addEventListener('pointerdown', function (e) {
      if (e.target.closest && e.target.closest('.lr2-vol, .lr2-volr')) { return; }
      self.firstGesture();
    }, true);
    r.addEventListener('keydown', function (e) { self.key(e); });
    r.addEventListener('pointerdown', function () { if (!r.contains(document.activeElement)) { try { r.focus({ preventScroll: true }); } catch (e) {} } });   // so the keys work right after a click
    // scrubbing: pointer capture on the bar; the video seeks once, on release (the preview and the time follow the pointer)
    var down = function (e) {
      if (e.button != null && e.button > 0) { return; }
      self.scrubbing = true; r.classList.add('lr2-scrub'); self.firstGesture();
      try { bar.setPointerCapture(e.pointerId); } catch (x) {}
      self.scrubTo(e); e.preventDefault();
    };
    bar.addEventListener('pointerdown', down);
    bar.addEventListener('pointermove', function (e) { self.hover(e); if (self.scrubbing) { self.scrubTo(e); } });
    bar.addEventListener('pointerup', function (e) { if (!self.scrubbing) { return; } self.scrubbing = false; r.classList.remove('lr2-scrub'); try { bar.releasePointerCapture(e.pointerId); } catch (x) {} self.seekClock(self.fracAt(e) * self.model.dur, true); });
    bar.addEventListener('pointercancel', function () { self.scrubbing = false; r.classList.remove('lr2-scrub'); self.syncUI(); });
    bar.addEventListener('pointerleave', function () { if (!self.scrubbing) { self.tip.classList.remove('lr2-on'); } });
    bar.addEventListener('keydown', function (e) {
      if (!self.model) { return; }
      var k = e.key, step = e.shiftKey ? 30 : 5, h = true;
      if (k === 'ArrowLeft' || k === 'ArrowDown') { self.skip(-step); } else if (k === 'ArrowRight' || k === 'ArrowUp') { self.skip(step); }
      else if (k === 'Home') { self.seekClock(0); } else if (k === 'End') { self.seekClock(self.model.dur - 1000); }
      else if (k === 'PageUp') { self.chapter(-1); } else if (k === 'PageDown') { self.chapter(1); } else { h = false; }
      if (h) { e.preventDefault(); e.stopPropagation(); }
    });
    // trackpad / wheel: a horizontal swipe over the card or the bar scrubs (vertical scroll is left alone)
    var acc = 0, accT = 0;
    var wheel = function (e) {
      if (!self.model || Math.abs(e.deltaX) <= Math.abs(e.deltaY) * 1.3 || Math.abs(e.deltaX) < 1) { return; }
      e.preventDefault();
      acc += e.deltaX; clearTimeout(accT);
      var spp = clamp(0.1 * (self.model.dur / 1000) / 600, 0.08, 0.6);   // seconds of replay per pixel of swipe: a long replay moves faster than a short one
      var target = (self.pendingSeek != null ? self.pendingSeek : self.clockMs()) + e.deltaX * spp * 1000;
      self.seekClock(target);
      accT = setTimeout(function () { acc = 0; }, 200);
    };
    this.card.addEventListener('wheel', wheel, { passive: false });
    bar.addEventListener('wheel', wheel, { passive: false });
    window.addEventListener('resize', function () { if (self.model) { clearTimeout(self.rsz); self.rsz = setTimeout(function () { self.drawLane(); }, 120); } });
    window.addEventListener('pagehide', function () { self.persist(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) { self.persist(); } });
    if (window.ResizeObserver) { new ResizeObserver(function () { clearTimeout(self.rsz); self.rsz = setTimeout(function () { if (self.model) { self.drawLane(); } }, 100); }).observe(this.main); }
  };
  Player.prototype.scrubTo = function (e) {
    var f = this.fracAt(e), ms = f * this.model.dur;
    this.fillEl.style.transform = 'scaleX(' + f + ')'; this.knob.style.left = (f * 100) + '%';
    this.timeEl.textContent = fmt(ms) + ' / ' + fmt(this.model.dur);
    this.updateInfo(ms); this.hover(e);
  };
  Player.prototype.chapter = function (dir) {
    var chs = ((this.m.markers && this.m.markers.chapters) || []).filter(function (c) { return c.kind !== 'resume'; }), ms = this.clockMs(), i;
    if (dir > 0) { for (i = 0; i < chs.length; i++) { if (chs[i].t_ms > ms + 1500) { this.seekClock(chs[i].t_ms, true); return; } } }
    else { for (i = chs.length - 1; i >= 0; i--) { if (chs[i].t_ms < ms - 3000) { this.seekClock(chs[i].t_ms, true); return; } } }
  };
  Player.prototype.key = function (e) {
    if (e.ctrlKey || e.metaKey || e.altKey) { return; }
    var t = e.target, tag = t && t.tagName;
    if (tag === 'INPUT' && t.type !== 'range') { return; }
    if (t === this.barEl) { return; }
    if (this.menuEl && this.menuEl.contains(t)) { return; }
    var k = e.key, h = true;
    if (!this.model) { return; }
    if (k === ' ' || k === 'k' || k === 'K') { if (tag === 'BUTTON' && k === ' ') { return; } this.firstGesture(); this.toggle(); }
    else if (k === 'ArrowLeft') { if (tag === 'INPUT') { return; } this.skip(e.shiftKey ? -10 : -5); }
    else if (k === 'ArrowRight') { if (tag === 'INPUT') { return; } this.skip(e.shiftKey ? 10 : 5); }
    else if (k === 'j' || k === 'J') { this.skip(-10); } else if (k === 'l' || k === 'L') { this.skip(10); }
    else if (k === 'ArrowUp') { if (tag === 'INPUT') { return; } this.userMuted = false; this.setVol((this.vid().muted ? 0 : this.vid().volume) + 0.1); }
    else if (k === 'ArrowDown') { if (tag === 'INPUT') { return; } this.setVol(this.vid().volume - 0.1); }
    else if (k === 'm' || k === 'M') { this.bVol.click(); }
    else if (k === 'f' || k === 'F') { this.fullscreen(); }
    else if (k === 'c' || k === 'C') { this.toggleFeed(); }
    else if (k === '>' || k === '.') { this.setRate(SPEEDS[Math.min(SPEEDS.length - 1, SPEEDS.indexOf(this.rate || 1) + 1)]); }
    else if (k === '<' || k === ',') { this.setRate(SPEEDS[Math.max(0, SPEEDS.indexOf(this.rate || 1) - 1)]); }
    else if (k === 'Home') { this.seekClock(0); } else if (k === 'End') { this.seekClock(this.model.dur - 1000); }
    else if (/^[0-9]$/.test(k)) { this.seekClock(this.model.dur * (+k) / 10, true); }
    else if (k === 'Escape' && this.menuEl) { this.closeMenu(); }
    else { h = false; }
    if (h) { e.preventDefault(); }
  };

  /* play when it is mostly on screen the first time (muted: always allowed); never fight a pause the member chose */
  Player.prototype.observe = function () {
    var self = this, started = false;
    var go = function () {
      if (started || self.dead) { return; } started = true;
      if (!self.vid().muted) { self.vid().muted = true; }
      self.autoMuted = true; self.syncVol();
      self.wantPlay = true; self.tryPlay(self.vid());
    };
    /* A REPLAY OPENED ON ITS OWN PAGE STARTS AT ONCE (2026-11-04, Rob: "it just loads a photo", even in Chrome): the page is the reader's deliberate open, and the old "40% of the CARD on screen" test could
       never pass when the portrait card is taller than the window (a tall card + a short window = under 40% visible, forever), so the poster just sat there. Anywhere else (a card in a feed) it still waits to be seen,
       and "seen" now also counts 40% of the WINDOW's height. */
    if (!window.IntersectionObserver || (location.pathname.indexOf('/p/') === 0)) { go(); return; }
    var io = new IntersectionObserver(function (es) {
      var e = es[0]; if (!e.isIntersecting) { return; }
      var vh = window.innerHeight || document.documentElement.clientHeight || 800;
      if (e.intersectionRatio >= 0.4 || (e.intersectionRect && e.intersectionRect.height >= vh * 0.4)) { io.disconnect(); go(); }
    }, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.7] });
    io.observe(this.card);
  };

  /* ------------------------------------------------------------------ boot ------------------------------------------------------------------ */
  var players = [];
  function mount(n) {
    if (n.__lr2) { return; } n.__lr2 = 1;
    try { players.push(new Player(n)); } catch (e) {
      n.innerHTML = '<div class="lr2-err"><div class="lr2-msg">This replay could not start.</div><div class="lr2-errb"><a class="lr2-pill lr2-ghost" href="' + esc(location.pathname + '?replay=1') + '">Open classic player</a></div></div>';
      if (window.console) { console.error('[replay2]', e); }
    }
  }
  function boot() {
    var ns = document.querySelectorAll('.lr2[data-lr2]'), i;
    for (i = 0; i < ns.length; i++) { mount(ns[i]); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  window.__rovaReplay2 = { players: players, mount: mount, boot: boot, Model: Model };
})();
